export enum ClientTypeEnum {
  Male = 1,
  Female = 2,
  Corporation = 3,
}

export enum ClientGenderEnum {
  Male = "1",
  Female = "2",
}

export enum ContracTypeEnum {
  Individual = "0",
  Corporation = "3",
}
